// Pure barbell plate math — what to load on each side to hit a target weight.
// Unit-agnostic: pass weights + plate set in the same unit (kg or lb).
// Kept dependency-free so it's unit-testable (see test/plates.test.js).

// Default "what most people own" sets (used until the user customises theirs).
export const KG_PLATES = [25, 20, 15, 10, 5, 2.5, 1.25];
export const LB_PLATES = [45, 35, 25, 10, 5, 2.5];
// Full menu of common denominations offered as toggles in the plate editor.
export const KG_PLATE_OPTIONS = [25, 20, 15, 10, 5, 2.5, 2, 1.5, 1.25, 1, 0.5];
export const LB_PLATE_OPTIONS = [45, 35, 25, 10, 5, 2.5, 1.25];
export const DEFAULT_BAR_KG = 20;
export const DEFAULT_BAR_LB = 45;

/**
 * Greedy plate breakdown for ONE side of the bar.
 * @param {number} target  total target weight (bar + all plates)
 * @param {number} bar     bar weight
 * @param {number[]} plates available plate denominations (one side's worth)
 * @returns {{target:number,bar:number,perSide:number[],perSideWeight:number,remainder:number,achievable:boolean,belowBar:boolean}}
 */
export function computePlates(target, bar, plates = KG_PLATES) {
  const result = { target, bar, perSide: [], perSideWeight: 0, remainder: 0, achievable: false, belowBar: false };
  if (typeof target !== "number" || isNaN(target) || typeof bar !== "number" || isNaN(bar)) return result;

  const perSideWeight = (target - bar) / 2;
  if (perSideWeight < 0) {
    result.belowBar = true;
    return result;
  }
  result.perSideWeight = round2(perSideWeight);

  const EPS = 1e-6;
  let remaining = perSideWeight;
  for (const p of [...plates].sort((a, b) => b - a)) {
    while (remaining + EPS >= p) {
      result.perSide.push(p);
      remaining -= p;
    }
  }
  result.remainder = round2(remaining);
  result.achievable = result.remainder < EPS;
  return result;
}

function round2(n) {
  return Math.round(n * 100) / 100;
}
